import type { PendingFile } from '@/types/upload'
import { FileItem } from './FileItem'

export interface FileListProps {
  files: PendingFile[]
  onRemoveFile: (id: string) => void
}

/**
 * List component for displaying pending/uploaded files.
 */
export function FileList({ files, onRemoveFile }: FileListProps) {
  if (files.length === 0) {
    return (
      <div
        className="text-center py-8 text-gray-500"
        data-testid="file-list-empty"
      >
        <p>No files selected</p>
        <p className="text-sm mt-1">
          Drag and drop files or click to browse
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-2" data-testid="file-list">
      {files.map((file) => (
        <FileItem
          key={file.id}
          file={file}
          onRemove={() => onRemoveFile(file.id)}
        />
      ))}
    </div>
  )
}

export default FileList
